import { CharacterCount } from './character-count'

export * from './character-count'

export default CharacterCount